import { Pagination } from "@next-platform/client-common-spicy-ui";
import { useCallback } from "react";
import { usePagination } from "react-instantsearch";

import { SEARCH_CLIENT_INITIAL_VISIBLE_PAGE_COUNT } from "@/constants/characters";

const SearchClientPagination = () => {
  const { currentRefinement, nbPages, canRefine, refine } = usePagination();

  const handlePageChange = useCallback(
    (page: number) => {
      refine(page - 1);
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    },
    [refine],
  );

  if (!canRefine) {
    return null;
  }

  return (
    <Pagination
      count={nbPages}
      initialVisiblePageCount={SEARCH_CLIENT_INITIAL_VISIBLE_PAGE_COUNT}
      onChange={handlePageChange}
      page={currentRefinement + 1}
    />
  );
};

export default SearchClientPagination;
